export const steamRateMap: any = {
  OverwhelminglyPositive: {
    icon: 'good-icon',
    name: 'Overwhelmingly Positive',
  },
  VeryPositive: {
    icon: 'good-icon',
    name: 'Very Positive',
  },
  MostlyPositive: {
    icon: 'good-icon',
    name: 'Mostly Positive',
  },
  Mixed: {
    icon: 'mixed-icon',
    name: 'Mixed',
  },
  MostlyNegative: {
    icon: 'no-good-icon',
    name: 'Mostly Negative',
  },
  VeryNegative: {
    icon: 'no-good-icon',
    name: 'Very Negative',
  },
  OverwhelminglyNegative: {
    icon: 'no-good-icon',
    name: 'Overwhelmingly Negative',
  },
};

export const channelSortList = [
  'youtube',
  'tiktok',
  'douyin',
  'facebook',
  'twitter',
  'instagram',
  'twitch',
  'bilibili',
  'discord',
  'reddit',
  'vk',
];



